import ContentActions from '@/content/actions/content.actions';
import ContentMutations from '@/content/mutations/content.mutations';
import { ContentStore } from '../models/content-store.model';

const MY_CONTENT_STORE_NAME = 'MyContentStore';

export const MY_CONTENT_MUTATIONS_NAMES = {
  SET_CONTENT: 'setContent',
  SET_PAGE_NAME: 'setPageName',
  SET_PAGE: 'setPage',
  SET_COURSES_ALREADY_LOADED: 'setCoursesAlreadyLoaded',
  SET_HOMEWORK_RESPONSE_SENT: 'setHomeworkResponseSent',
  UPDATE_HOMEWORK_FROM_COURSE: 'updateHomeworkFromCourse',
  INIT_COURSES: 'initCourses',
  REFRESH_CONTENT: 'refreshContent',
  UPDATE_CONTENT_STATUS: 'updateContentStatus',
  REMOVE_CONTENT: 'removeContent',
  SET_COURSES: 'setCourses',
  BLOCK_SUBJECT_TO_SHARE: 'blockSubjectToShare',
  UNBLOCK_SUBJECT_TO_SHARE: 'unblockSubjectToShare',
  SET_SINGLE_CONTENT: 'setSingleContent'
};

export const MY_CONTENT_ACTIONS_NAMES = {
  GET_CONTENT: 'getContent',
  GET_CONTENT_BY_EDITOR: 'getContentByEditor',
  GET_COURSES_WITH_HOMEWORKS: 'getCoursesWithHomeworks',
  GET_HOMEWORKS_FROM_COURSE: 'getHomeworksFromCourse',
  RESPONSE_HOMEWORK: 'responseHomework',
  REMOVE_CONTENT: 'removeContent',
  GET_CONTENT_STATUS_BY_ID: 'getContentStatusById',
  REMOVE_CONTENT_FROM_STORE: 'removeContentFromStore',
};

export const MY_CONTENT_STORE = {
  NAME: MY_CONTENT_STORE_NAME,
  MUTATIONS: {
    SET_PAGE_NAME:`${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.SET_PAGE_NAME}`,
    SET_CONTENT: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.SET_CONTENT}`,
    SET_PAGE: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.SET_PAGE}`,
    SET_COURSES_ALREADY_LOADED: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.SET_COURSES_ALREADY_LOADED}`,
    SET_HOMEWORK_RESPONSE_SENT: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.SET_HOMEWORK_RESPONSE_SENT}`,
    UPDATE_HOMEWORK_FROM_COURSE: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.UPDATE_HOMEWORK_FROM_COURSE}`,
    INIT_COURSES: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.INIT_COURSES}`,
    REFRESH_CONTENT: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.REFRESH_CONTENT}`,
    UPDATE_CONTENT_STATUS: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.UPDATE_CONTENT_STATUS}`,
    BLOCK_SUBJECT_TO_SHARE: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.BLOCK_SUBJECT_TO_SHARE}`,
    UNBLOCK_SUBJECT_TO_SHARE: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.UNBLOCK_SUBJECT_TO_SHARE}`,
    SET_SINGLE_CONTENT: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_MUTATIONS_NAMES.SET_SINGLE_CONTENT}`,
  },
  ACTIONS: {
    GET_CONTENT: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_ACTIONS_NAMES.GET_CONTENT}`,
    GET_COURSES_WITH_HOMEWORKS: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_ACTIONS_NAMES.GET_COURSES_WITH_HOMEWORKS}`,
    GET_HOMEWORKS_FROM_COURSE: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_ACTIONS_NAMES.GET_HOMEWORKS_FROM_COURSE}`,
    RESPONSE_HOMEWORK: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_ACTIONS_NAMES.RESPONSE_HOMEWORK}`,
    REMOVE_CONTENT: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_ACTIONS_NAMES.REMOVE_CONTENT}`,
    GET_CONTENT_STATUS_BY_ID: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_ACTIONS_NAMES.GET_CONTENT_STATUS_BY_ID}`,
    REMOVE_CONTENT_FROM_STORE: `${MY_CONTENT_STORE_NAME}/${MY_CONTENT_ACTIONS_NAMES.REMOVE_CONTENT_FROM_STORE}`,
  }
}

export const MyContentStore = {
  namespaced: true, 
  state: {

    /* Content */
    pageName: '',
    subjects: new ContentStore(),
    purchased: new ContentStore(),

    /* Courses with Homeworks */
    coursesAlreadyLoad: false

  },
  mutations: {
    setPageName: ContentMutations.setPageName,
    setContent: ContentMutations.setContent,
    removeContent: ContentMutations.removeContent,
    setPage: ContentMutations.setPage,
    setCoursesAlreadyLoaded: ContentMutations.setCoursesAlreadyLoaded,
    initCourses: ContentMutations.initCourses,
    refreshContent: ContentMutations.refreshContent,
    updateContentStatus: ContentMutations.updateContentStatus,
    initState: ContentMutations.initState,
    blockSubjectToShare: ContentMutations.blockSubjectToShare,
    unblockSubjectToShare: ContentMutations.unblockSubjectToShare,
    setSingleContent: ContentMutations.setSingleContent
  },
  actions: {
    getContent: ContentActions.getContent,
    getContentStatusById: ContentActions.getContentStatusById,
    removeContent: ContentActions.removeContent,
    removeContentFromStore: ContentActions.removeContentFromStore,
  }
};
